/**
 * Attrs для дилерской формы лизинговой заявки, которую открывает CTA «Reserve»
 * на Lease-табе лендинга Andys (#1256).
 *
 * Вынесено из `AndysLandingConnected` чистой функцией: именно эта форма attrs
 * определяет, с какими полями лид уедет в CRM (`formType` → source «Leasing
 * Enquiry» + intent leasing; `formExtra` → что именно выбрал клиент), поэтому
 * логика должна быть покрыта тестом, а не проверяться только руками.
 *
 * Паттерн — как у `CarDetailPage` (#1087): `presentation: 'modal'` +
 * `formModalOpen`, потому что своим CTA владеет лендинг, а форма монтируется
 * только на время показа и размонтируется в `onClose`.
 */

/**
 * Код дилерского form-template лизинговой заявки. ТОТ ЖЕ, что в маркере на
 * страницах лизинга Andys (`<div data-shiftgears="form"
 * data-template-id="leasing_booking">` — сверено на живой
 * /nissan-march-leasing), и встроенный дефолт b2b-api
 * (`form-template-defaults.ts`).
 */
export const ANDYS_LEASE_FORM_TEMPLATE = 'leasing_booking';

/**
 * @param {{id: string, label: string, priceFrom: number}|null|undefined} category
 *   выбранная категория лизинга.
 * @returns {object|null} attrs для `<LeadFormEmbed>`, либо null если категории
 *   нет (тогда форму не рендерим вовсе).
 */
export function buildLeaseReserveAttrs(category) {
  if (!category) return null;

  return {
    formTemplateCode: ANDYS_LEASE_FORM_TEMPLATE,
    // formType дублирует значение из темплейта СОЗНАТЕЛЬНО: per-embed attr
    // имеет приоритет над темплейтом, поэтому CRM-source остаётся верным даже
    // если реестр темплейтов до виджета не доехал (см. #1258) и форма
    // отрендерилась с дефолтной копией.
    formType: 'leasing_booking',
    // `{car}` в заголовке темплейта подставится названием категории.
    carTitle: category.label,
    presentation: 'modal',
    formModalOpen: true,
    formExtra: {
      intent: 'leasing',
      leaseCategory: category.label,
      leaseCategoryId: category.id,
      priceFrom: category.priceFrom,
    },
  };
}

export default buildLeaseReserveAttrs;
